import { useWindowDimensions } from "react-native";

/**
 * Responsive horizontal gap (Tailwind class) used between the main content
 * column and the right panel / sidebar on multi-column screens. Keeps the
 * spacing consistent across feeds, events, groups, leaderboard, etc.
 */
export const useResponsiveGap = (): string => {
  const { width } = useWindowDimensions();

  if (width >= 1280) return "gap-14";
  if (width >= 1024) return "gap-10";
  if (width >= 768) return "gap-7";
  return "gap-5";
};
